<div class="list-container">
  <rask-list [data]="sortiment">
    <rask-list-column header="{{ 'SORTIMENT_DETAIL_NAMN' | translate }}" field="namn" width="30%" [sortable]="true">
      <ng-template let-row="row">
        <a href="#" (click)="open($event,row)">{{row.namn}}</a>
      </ng-template>
    </rask-list-column>
    <rask-list-column header="{{ 'SORTIMENT_DETAIL_KOD' | translate }}" field="kod" width="15%" [sortable]="true"></rask-list-column>
    <rask-list-column header="{{ 'SORTIMENT_DETAIL_PRODUKTGRUPP' | translate }}" field="produktgruppNamn" width="40%" [sortable]="true"></rask-list-column>
    <rask-list-column header="{{ 'SORTIMENT_DETAIL_AKTIV' | translate }}" field="aktiv" width="15%">
      <ng-template let-value>
        @if (value) {
          <i class="far fa-check"></i>
        }
      </ng-template>
    </rask-list-column>
  </rask-list>
</div>